import { queryAll, query, fromId } from '../utils/utils.js';
import instantsearch from 'instantsearch.js';

import algoliasearch from "algoliasearch";
import {
	configure,
	hits,
	pagination,
	searchBox,
	stats,
	currentRefinements,
	clearRefinements,
	refinementList,
	sortBy
} from 'instantsearch.js/es/widgets';
import { connectAutocomplete, connectCurrentRefinements, connectClearRefinements } from 'instantsearch.js/es/connectors';
import { searchScroll } from '../parts/search-scroll.js';
import { setAisSearchBoxAriaLabel } from './accessibility-helpers.js';

const SERVICE_SEARCH_ARIA_LABEL = 'Search services';

export class ServiceSearch {

	constructor() {
		// this.init();
	}


	init(){
		let doViewAll = false;

		const search = instantsearch({
			indexName: window.ALGOLIA_INDEX_PREFIX+'services',
			searchClient: algoliasearch(
			  'LTCGWA12RB',
			  'fbbd5f8b545361104df6b21dfd244cc1'
			),
			routing: true,
			// searchFunction(helper) {
			// 	if(helper.state.query){
			// 		helper.search();
			// 	}
			// },
		});


		search.addWidgets([
			searchBox({
				container: "#searchbox",
				placeholder: "Search (ie diabetes, stroke, Pittsfield)"

			}),
			configure({
				hitsPerPage: 999999,
			}),
			//big boxes
			refinementList({
				container: '#alpha-chooser',
				attribute: 'alpha',
				operator: 'or',
				sortBy: ['name:asc'],
				limit: 99,
				transformItems: (items) => {
					//add the missing letters to our facet
					for (let i = 97; i <= 122; i++) {
						const letter = String.fromCharCode(i).toUpperCase();
						if (!items.find(item => item.label === letter)) {
							items = [...items, {label: letter, value: letter, count: 0}];
						}
					}
					items = items.sort((a, b) => a.label.localeCompare(b.label));
					return items;
				},
				templates: {
					item(item, { html }) {
					  const { url, label, count, isRefined } = item;

					  return html`
					  	<div class="item-type item ${isRefined ? 'checked' : ''}  ${count >= 1 ? '' : 'inactive'}">
							<a href="${url}" >
								<span>${label}</span>
							</a>
						</div>
					  `;
					},
				  },

			}),
			refinementList({
				container: '#alpha-chooser-mobile',
				attribute: 'alpha',
				operator: 'or',
				sortBy: ['name:asc'],
				limit: 99,
				transformItems: (items) => {
					//add the missing letters to our facet
					for (let i = 97; i <= 122; i++) {
						const letter = String.fromCharCode(i).toUpperCase();
						if (!items.find(item => item.label === letter)) {
							items = [...items, {label: letter, value: letter, count: 0}];
						}
					}
					items = items.sort((a, b) => a.label.localeCompare(b.label));
					return items;
				},
				templates: {
					item(item, { html }) {
					  const { url, label, count, isRefined } = item;

					  return html`
					  	<div class="item-type item ${isRefined ? 'checked' : ''}  ${count >= 1 ? '' : 'inactive'}">
							<a href="${url}" >
								<span>${label}</span>
							</a>
						</div>
					  `;
					},
				  },

			}),
			// <div class="main-term">${hit.main_term}</div>
			hits({
				container: "#hits",
				templates: {
				empty(results, { html }) {
					return html`<div class="no-results">No results found for <q>${results.query}</q></div>`;
				},
				item(hit, { html, components }) {
					return html`
						<div class="search-result" data-alpha="${hit.alpha}">
							<div class="alpha">${hit.alpha}</div>
							<div class="result-col">
								<a href="${hit.url}" class="service-title">${hit.title}</a>
							</div>
						</div>
					`;
					},
				},
			})
		]);

		search.start();
		setAisSearchBoxAriaLabel('#searchbox', SERVICE_SEARCH_ARIA_LABEL);
		let firstRender = true;


		searchScroll();



		search.on('render', () => {
			setAisSearchBoxAriaLabel('#searchbox', SERVICE_SEARCH_ARIA_LABEL);
			window.addArrowLinks();

			if (search.helper?.lastResults?.hits?.length === 0){
				document.querySelector('.search-page')?.classList.add("no-results-found")
			}else{
				document.querySelector('.search-page')?.classList.remove("no-results-found")
			}

			const elements = document.querySelectorAll('.search-result');
			for (let i = 0; i < elements.length; i++) {
				if (elements[i].getAttribute("data-alpha") !== elements[i - 1]?.getAttribute("data-alpha")) {
					elements[i].classList.remove("hide-alpha");
				}else{
					elements[i].classList.add("hide-alpha");
				}
			}

			if(firstRender){
				firstRender = false;
			}
		});
	}
}
